import { render, staticRenderFns } from "./staffingPortalTv.vue?vue&type=template&id=63cd267e&scoped=true"
import script from "./staffingPortalTv.vue?vue&type=script&lang=js"
export * from "./staffingPortalTv.vue?vue&type=script&lang=js"
import style0 from "./staffingPortalTv.vue?vue&type=style&index=0&id=63cd267e&prod&lang=css"
import style1 from "./staffingPortalTv.vue?vue&type=style&index=1&id=63cd267e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63cd267e",
  null
  
)

export default component.exports